import { loadStripe } from '@stripe/stripe-js';
import { AnimatedButton } from '@ts/components/AnimatedButton';

export const getStripeElements = async () => {
    const paymentArea = document.getElementById('payment-area');
    if (!paymentArea) return;
    const clientSecret = paymentArea.dataset.clientSecret;
    const publishableKey = paymentArea.dataset.publishableKey;
    const stripe = await loadStripe(publishableKey);

    const appearance = {
        theme: 'stripe',
        rules: {
            '.Tab': {
                border: '1px solid #E0E0E0',
                boxShadow: 'none',
            },
            '.Tab--selected': {
                border: '1px solid #1E3347',
                boxShadow: 'none',
            },
            '.Tab--selected:focus': {
                border: '1px solid #1E3347',
                boxShadow: 'none',
            }
        },
        variables: {
            fontFamily: '"DM Sans", sans-serif',
            fontSizeBase: '16px',
            colorBackground: '#ffffff',
            colorText: '#212529',
            colorTextPlaceholder: '#707070',
            colorPrimary: '#1E3347',
            colorDanger: '#e53935',
            colorBackground: '#ffffff',
            borderRadius: '6px'
        },
    };

    const elements = stripe.elements({
        clientSecret: clientSecret,
        appearance: appearance
    });

    const options = {
        business: { name: "Funderworks" },
        layout: {
            type: 'tabs'
        }
    }

    const paymentElement = elements.create('payment', options);
    paymentElement.mount('#payment-element');

    return {
        paymentProvider: stripe, 
        paymentElements: elements
    };
}